export default "__VITE_ASSET__CrmI3znw__"